var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13943_8854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 2.66666H4.53331C3.41321 2.66666 2.85316 2.66666 2.42533 2.88464C2.04901 3.07639 1.74305 3.38235 1.5513 3.75867C1.33331 4.1865 1.33331 4.74655 1.33331 5.86666V11.4667C1.33331 12.5868 1.33331 13.1468 1.5513 13.5746C1.74305 13.951 2.04901 14.2569 2.42533 14.4487C2.85316 14.6667 3.41321 14.6667 4.53331 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1153 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.3333 10.6667H6.44966C6.77578 10.6667 6.93884 10.6667 7.09229 10.6298C7.22834 10.5972 7.3584 10.5433 7.47769 10.4702C7.61225 10.3877 7.72755 10.2724 7.95815 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.781 1.11437 12.8856 1.11437 12.3333 1.66665L5.95814 8.04182C5.72753 8.27242 5.61223 8.38772 5.52978 8.52228C5.45667 8.64157 5.4028 8.77163 5.37014 8.90768C5.3333 9.06113 5.3333 9.22419 5.3333 9.55031V10.6667Z",
    stroke: "#512DA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13943_8854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.ad62b860be53b391064fef7a34d21b3f.svg";
export { ForwardRef as ReactComponent };